import { motion } from "framer-motion";
import { MessageSquare, CreditCard, UserX, Calculator } from "lucide-react";

const problems = [
  {
    icon: CreditCard,
    title: "The \"Who Pays?\" Problem",
    description: "Someone fronts ₹20K for bottle service. Trust issues. Cash flow burden. Messy splitting.",
    stat: "₹20K+",
    statLabel: "often fronted per night",
  },
  {
    icon: MessageSquare,
    title: "The \"Where?\" Problem",
    description: "47 messages debating which bar. Decision paralysis. By the time you decide, prime time is over.",
    stat: "47+ msgs",
    statLabel: "typical group chat",
  },
  {
    icon: UserX,
    title: "The No-Show Problem",
    description: "10 people say \"I'm in.\" 3 show up. Someone already paid for 10. Wasted money, killed vibe.",
    stat: "~70%",
    statLabel: "common flake rate (illustrative)",
  },
  {
    icon: Calculator,
    title: "Settlement Hell",
    description: "6 separate UPI transfers. IOUs that never get paid. Friendship tension over money.",
    stat: "6+ txns",
    statLabel: "typical to settle one night",
  },
];

const ProblemSection = () => {
  return (
    <section className="section-padding bg-background">
      <div className="mx-auto max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-16 text-center"
        >
          <span className="mb-4 inline-block text-sm font-semibold uppercase tracking-widest text-secondary">
            The Problem
          </span>
          <h2 className="mx-auto max-w-2xl text-4xl font-bold leading-tight md:text-5xl">
            Nightlife is <span className="text-gradient-gold">social</span>, but the economics are{" "}
            <span className="text-destructive">broken</span>.
          </h2>
        </motion.div>

        <div className="grid gap-6 md:grid-cols-2">
          {problems.map((problem, i) => (
            <motion.div
              key={problem.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="group rounded-2xl border border-border bg-card p-8 transition-all hover:border-destructive/30"
            >
              <div className="mb-4 flex items-start justify-between">
                <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-destructive/10">
                  <problem.icon className="h-6 w-6 text-destructive" />
                </div>
                <div className="text-right">
                  <p className="text-2xl font-bold text-foreground">{problem.stat}</p>
                  <p className="text-xs text-muted-foreground">{problem.statLabel}</p>
                </div>
              </div>
              <h3 className="mb-2 text-xl font-semibold text-foreground">{problem.title}</h3>
              <p className="text-sm leading-relaxed text-muted-foreground font-body">{problem.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
